import { useBrandIdentity } from 'hooks/useBrandIdentity';
import React from 'react';

type BrandEmptyListImageProps = React.ImgHTMLAttributes<HTMLImageElement>;

export const BrandEmptyListImage: React.FC<BrandEmptyListImageProps> = ({
    className = 'EmptyList',
    alt = '',
    ...imgProps
}) => {
    const { emptyListImage } = useBrandIdentity();

    return <img src={emptyListImage} alt={alt} className={className} {...imgProps} />;
};
